
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import AssetMixin from "../../../../../mixin/AssetMixin";
import { ModalID } from "@/enums/ModalID";
import ActionButton from "@/pages/shared/components/buttons/ActionButton.vue";
import { ActionID } from "@/enums/ActionID";

@Component({
  components: { ActionButton },
})
export default class NewPortfolioAction extends mixins(Vue, AssetMixin) {
  id = ActionID.NEW_PORTFOLIO;

  get isDisabled(): boolean {
    return !this.hasData;
  }

  openModal(): void {
    if (!this.isDisabled) {
      Vue.prototype.$modal.show(ModalID.NEW_PORTFOLIO);
    }
  }

  get hasData(): boolean {
    return this.$store.getters.totalSecuritiesCount > 0;
  }
}
